import { a } from '@react-spring/web';
import { flattenMessages } from '../flattenMessages';

export default flattenMessages({
  common: {
    saveChanges: 'Save changes',
    cancel: 'Cancel',
    save: 'Save',
    submit: 'Submit',
    weekDays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    greeting: 'Hello, {name}!',
    clear: 'Clear',
    applyFilters: 'Apply filters',
    back: 'Back',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    name: 'Name',
    actions: 'Actions',
    clearAllFilters: 'Clear all filters',
    status: 'Status',
    location: 'Location',
    yes: 'Yes',
    no: 'No',
    unknownError: 'Something went wrong',
    qualification: 'Position',
    shiftType: 'Shift Type',
    view: 'View',
    edit: 'Edit',
    deleteImage: 'Delete image',
    fileValidationError: 'Wrong file format: image should be PNG or JPG format, {sizeMb}MB max.',
    errors: {
      base: 'Something went wrong',
    },
  },
  system: {
    newVersionLabel: {
      message: {
        title: 'A new update is available. Please reload the page to apply the latest changes.',
      },
      refreshButton: {
        label: 'Refresh',
      },
    },
  },
  auth: {
    login: {
      title: 'Login',
      subtitle: 'Please, provide your email or phone number to receive an OTP',
      tabEmailTitle: 'Email',
      tabPhoneTitle: 'Phone number',
      emailPlaceholder: 'e.g. jhondoe@gmail.com',
      signUpText: 'Don’t have a ShiftNex account yet? <link>Sign Up</link>',
    },
    otp: {
      title: 'Secure verification',
      subtitle: 'We’ve just sent you a temporary 6-digit code verification. Please check email and/or phone.',
      inputPlaceholder: 'Enter the code',
      resendCode: 'Resend the code',
      resendCodeSuccess: 'Code successfully resent',
    },
    adminSignUp: {
      title: 'Welcome to ShiftNex!',
      titleWithName: '{name}, welcome to ShiftNex!',
      subtitle: 'Join the ShiftNex Healthcare Platform and enjoy the way we manage healthcare staffing operations',
      otpBySmsLabel: 'Receive OTP by sms',
      otpBySmsInstructions: 'Please, fill in your phone number if you want receive the one-time password  by SMS',
      submitLabel: 'Create account',
    },
    adminSignUpDetails: {
      title: 'Agency',
      subtitle: 'Please, fill in your agency details.',
    },
    adminSignUpAddress: {
      title: 'Address',
      subtitle: 'Please, fill in your agency address details.',
    },
    footer: {
      legalMessage:
        'By using {name} you agree to the <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>',
      version: 'Version {version}',
    },
    submitLabel: 'Continue',
    signInText: 'Already have a ShiftNex account? <link>Sign In</link>',
  },
  sidebar: {
    dashboard: 'Dashboard',
    clients: 'Clients',
    analytics: 'Analytics',
    settings: 'Settings',
  },
  header: {
    manageAccount: 'Manage account',
    profileMenu: {
      pauseNotificationsLabel: 'Pause notifications',
      profileSettingsLabel: 'Profile settings',
      supportLabel: 'Support chat',
      reportLabel: 'Report an issue',
      logOutLabel: 'Log out',
    },
    notificationSchedule: {
      label: 'Pause notifications for...',
      postponeMins: 'For {value, plural, one {# minute} other {# minutes}}',
      postponeHours: 'For {value, plural, one {# hour} other {# hours}}',
      postponeTomorrow: 'Until tomorrow',
    },
    refresh: {
      label: 'Last synced',
    },
  },
  comingSoon: {
    title: 'Coming soon...',
    description: 'The page is not yet available but we are working on it',
    votableDescription: {
      active:
        'We’re working hard to bring you powerful reporting features. Let us know how important this functionality is to you!',
      inactive: 'Thanks for voting! We’ll notify you when this feature is live.',
    },
    voteButton: {
      label: 'Vote for the feature',
    },
  },
  settings: {
    menu: {
      organization: {
        title: 'Organizations Values',
      },
      qualifications: {
        title: 'Positions',
      },
      linesOfBusiness: {
        title: 'Lines of Business',
      },
      agencyTypes: {
        title: 'Agency Types',
      },
      facilityTypes: {
        title: 'Facility Types',
      },
    },
    qualifications: {
      pageHeading: 'Positions',
      menu: {
        addButton: {
          label: 'Add position',
        },
      },
      filters: {
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No positions yet',
          subtitle: 'Shiftnex don’t have any positions yet',
        },
        fields: {
          qualification: {
            heading: 'Position',
          },
          abbreviation: {
            heading: 'Abbreviation',
          },
          category: {
            heading: 'Category',
          },
        },
      },
    },
    linesOfBusiness: {
      pageHeading: 'Lines Of Business',
      menu: {
        addButton: {
          label: 'Add line of business',
        },
      },
      filters: {
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No line of business yet',
          subtitle: 'Shiftnex don’t have any line of business yet',
        },
        fields: {
          name: {
            heading: 'Business line',
          },
        },
      },
    },
    agencyTypes: {
      pageHeading: 'Agency types',
      menu: {
        addButton: {
          label: 'Add agency type',
        },
      },
      filters: {
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No agency types yet',
          subtitle: 'Shiftnex don’t have any agency types yet',
        },
        fields: {
          name: {
            heading: 'Agency type',
          },
        },
      },
    },
    facilityTypes: {
      pageHeading: 'Facility types',
      menu: {
        addButton: {
          label: 'Add facility type',
        },
      },
      filters: {
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No facility types yet',
          subtitle: 'Shiftnex don’t have any facility types yet',
        },
        fields: {
          name: {
            heading: 'Facility type',
          },
        },
      },
    },
  },

  forms: {
    requiredFieldsMissing: '{number} mandatory fields missing',
    fieldIsRequired: 'This field is required',
    maxLengthError: 'Max length is {number}',
    minLengthError: 'Min length is {number}',
    invalidPhoneNumber: 'Please, enter valid phone number',
    invalidEIN: 'Please, check the format of the input',
    invalidZipCode: 'Please, enter valid zip code',
    invalidEmail: 'The entered value is not an email',
    emptyLinesOfBusiness: 'Select at least one business line of the organization',
    invalidWebsite: 'Please, enter valid website',
    positiveNumberOnly: 'Please, enter a positive number',
    maxValueError: 'Max number is {number}',
    minValueError: 'Min number is {number}',
  },
  filters: {
    dateRange: {
      previousQuarter: 'Previous quarter',
      previousWeek: 'Previous week',
      today: 'Today',
      thisWeek: 'This week',
      thisQuarter: 'This quarter',
      nextWeek: 'Next week',
      nextQuarter: 'Next quarter',
    },
    sharedWithin: {
      menuLabel: 'Shared within',
      last24Hours: 'Last 24 hours',
      last48Hours: 'Last 48 hours',
      allTime: 'All time',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
    },
    applyButtonLabel: 'Apply filters',
    departments: {
      label: 'Departments',
    },
    statuses: {
      label: 'Status',
    },
  },
  reports: {
    title: 'Reporting',
  },
  clients: {
    subpageMenu: {
      requests: 'Requests',
      agencies: 'Agencies',
      facilities: 'Facilities',
    },
    menuButton: {
      agency: 'Add agency',
      facility: 'Add facility',
    },

    requests: {
      orgTypes: {
        agency: {
          label: 'AX',
        },
        facility: {
          label: 'FX',
        },
      },
      table: {
        noRows: {
          title: 'No customer requests yet',
          subtitle: "Shiftnex don't have any customer requests yet",
        },
        fields: {
          orgType: {
            heading: 'Type',
          },
          createdOn: {
            heading: 'Created at',
          },
          orgName: {
            heading: 'Organization name',
          },
          tenant: {
            heading: 'Tenant',
          },
          address: {
            heading: 'Address',
          },
          phone: {
            heading: 'Phone',
          },
          mainContact: {
            heading: 'Contact',
          },
          status: {
            heading: 'Status',
          },
          actions: {
            heading: 'Quick actions',
            buttons: {
              activate: {
                label: 'Activate',
              },
              deactivate: {
                label: 'Deactivate',
              },
            },
          },
        },
      },
    },
    agencies: {
      statuses: {
        active: 'Active',
        disconnected: 'Disconnected',
        invited: 'Invited',
        onReview: 'On review',
        pending: 'Pending',
      },
      filters: {
        status: {
          label: 'Status',
        },
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No agencies yet',
          subtitle: "Shiftnex don't have any agency clients yet",
        },
        fields: {
          orgName: {
            heading: 'Agency name',
          },
          tenant: {
            heading: 'Tenant',
          },
          mainContact: {
            heading: 'Contact',
          },
          phone: {
            heading: 'Phone',
          },
          createdOn: {
            heading: 'Created at',
          },
          address: {
            heading: 'Address',
          },
          status: {
            heading: 'Status',
          },
          linesOfBusiness: {
            heading: 'Lines of business',
          },
        },
      },
    },
    facilities: {
      statuses: {
        active: 'Active',
        disconnected: 'Disconnected',
        invited: 'Invited',
        onReview: 'On review',
        pending: 'Pending',
      },
      filters: {
        status: {
          label: 'Status',
        },
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No facilities yet',
          subtitle: "Shiftnex don't have any facility clients yet",
        },
        fields: {
          orgName: {
            heading: 'Facility name',
          },
          tenant: {
            heading: 'Tenant',
          },
          mainContact: {
            heading: 'Contact',
          },
          phone: {
            heading: 'Phone',
          },
          status: {
            heading: 'Status',
          },
          createdOn: {
            heading: 'Created at',
          },
          address: {
            heading: 'Address',
          },
          facilityTypes: {
            heading: 'Facility types',
          },
          actionMenu: {
            activate: {
              label: 'Activate',
            },
            deactivate: {
              label: 'Deactivate',
            },
          },
        },
      },
    },
    drawers: {
      agency: {
        add: {
          dialogHeading: 'Add agency',
          menuButtons: {
            back: {
              label: 'Close',
            },
            addActivate: {
              label: 'Add and activate',
            },
            add: {
              label: 'Add',
            },
          },
          details: {
            sectTitle: 'Agency details',
            agencyName: {
              label: 'Agency name',
              placeholder: 'Enter agency name',
            },
            domainName: {
              label: 'Domain name',
              placeholder: 'example',
              endAdornment: '.shiftnex.com',
            },
            agencyType: {
              label: 'Agency type',
              placeholder: 'Agency type',
            },
            linesOfBusiness: {
              label: 'Lines of business',
              placeholder: 'Lines of business',
              requiredMessage: 'Please select at least one line of business',
            },
          },
          contact: {
            sectTitle: 'Contact person details',
            firstName: {
              label: 'First name',
              placeholder: 'Enter first name',
            },
            lastName: {
              label: 'Last name',
              placeholder: 'Enter last name',
            },
            email: {
              label: 'Email',
              placeholder: 'john.doe@example.com',
            },
            phoneNumber: {
              label: 'Phone number',
              placeholder: 'Enter phone number',
            },
          },
          address: {
            sectTitle: 'Address',
            addressAddressFirst: {
              label: 'Address',
              placeholder: 'Enter street name, number',
              noLocations: 'No locations',
            },
            addressAddressSecond: {
              label: 'Address additional',
              placeholder: 'Any address details',
            },
            addressCity: {
              label: 'City',
              placeholder: 'City',
            },
            addressState: {
              label: 'State',
              placeholder: 'State',
            },
            addressZipCode: {
              label: 'Zip code',
              placeholder: 'XXXXX-XXXX',
            },
          },
          qualifications: {
            sectTitle: 'Positions',
            qualifications: {
              label: 'Positions',
              placeholder: 'Select a positions',
              noLocations: 'No locations',
            },
          },
        },
        edit: {},
      },
      facility: {
        add: {
          dialogHeading: 'Add facility',
          menuButtons: {
            back: {
              label: 'Close',
            },
            addActivate: {
              label: 'Add and activate',
            },
            add: {
              label: 'Add',
            },
          },
          details: {
            sectTitle: 'Facility details',
            agencyName: {
              label: 'Facility name',
              placeholder: 'Enter facility name',
            },
            domainName: {
              label: 'Domain name',
              placeholder: 'example',
              endAdornment: '.shiftnex.com',
            },
            numberOfEmployees: {
              label: 'Number of employees',
              placeholder: 'Select number of employees',
            },
            facilityTypes: {
              label: 'Facility types',
              placeholder: 'Facility type',
            },
          },
          contact: {
            sectTitle: 'Contact person details',
            firstName: {
              label: 'First name',
              placeholder: 'Enter first name',
            },
            lastName: {
              label: 'Last name',
              placeholder: 'Enter last name',
            },
            email: {
              label: 'Email',
              placeholder: 'john.doe@example.com',
            },
            phoneNumber: {
              label: 'Phone number',
              placeholder: 'Enter phone number',
            },
          },
          address: {
            sectTitle: 'Address',
            addressAddressFirst: {
              label: 'Address',
              placeholder: 'Enter street name, number',
              noLocations: 'No locations',
            },
            addressAddressSecond: {
              label: 'Address additional',
              placeholder: 'Any address details',
            },
            addressCity: {
              label: 'City',
              placeholder: 'City',
            },
            addressState: {
              label: 'State',
              placeholder: 'State',
            },
            addressZipCode: {
              label: 'Zip code',
              placeholder: 'XXXXX-XXXX',
            },
          },
        },
        edit: {},
      },
    },
  },
});
